import { i18n, lang } from '../../unit/const'
import { isMobile } from '../../unit'
export default {
  name: 'Guide',
  data() {
    return {
      isMobile: isMobile()
    }
  },
  computed: {
    linkTitle: () => i18n.linkTitle[lang],
    blog: () => i18n.blog[lang],
    QRCode: () => i18n.QRCode[lang],
    QRTitle: () => i18n.QRNotice[lang],
    QRSrc: () => './static/qr.png'
  },
  mounted() {
    window.addEventListener('resize', this.resize.bind(this), true)
  },
  methods: {
    resize() {
      this.isMobile = isMobile()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/guide/index.js